import React from 'react'
import Header from 'src/Components/Header'
import Homes from './Homes'
import Markets from './Markets'
import BuyingReport from './BuyingReport'

const HomeownersNavigation = ({ loaded }) => (
  <Header.Navigation loaded={loaded}>
    <Homes active to='#' />
    <Markets />
    <BuyingReport />
  </Header.Navigation>
)

export default HomeownersNavigation
